<template>
  <collection
    name="discount"
    :loading="loading"
    :options="options"
    :data="getAllDiscounts"
    :columns="1"
  >
    <template v-slot:action>
      <router-link :to="{name: 'NewDiscount'}" class="g-button">
        New
      </router-link>
    </template>
    <template v-slot:item="slotProps">
      <discount-preview v-bind="slotProps.record" />
    </template>
  </collection>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import searchConfig from '@/utilities/searchConfig';
import Collection from '@/components/Collection.vue';
import DiscountPreview from './DiscountPreview.vue';

export default {
  name: 'ListStrips',
  components: {
    Collection,
    DiscountPreview,
  },
  data() {
    return {
      loading: true,
      options: {
        search: {
          ...searchConfig,
          keys: ['code', 'value'],
        },
      },
    };
  },
  computed: {
    ...mapGetters(['getAllDiscounts']),
  },
  methods: {
    ...mapActions(['fetchAllDiscounts']),
  },
  mounted() {
    this.fetchAllDiscounts().finally(() => {
      this.loading = false;
    });
  },
};
</script>
